import { gql } from 'graphql-request';

import {
  UserEmail,
  UserFullName,
  UserImageFile,
  UserUUID,
  UserBalanceAmount,
  UserDebt,
  UserClient,
  UserCurrency,
  UserCurrentTeamNanoID
} from '../usersTypes';

export interface FetchUserNewMenuQueryResponse {
  uuid: UserUUID;
  balanceAmount: UserBalanceAmount;
  currency: UserCurrency;
  debt: UserDebt;
  email: UserEmail;
  fullName: UserFullName;
  client: UserClient;
  currentTeam: {
    nanoId: UserCurrentTeamNanoID;
  };
  image: {
    file: UserImageFile;
  };
}

export const FETCH_USER_NEW_MENU_QUERY = gql`
  query UserNewMenu($uuid: ID!) {
    user(uuid: $uuid) {
      uuid
      balanceAmount
      currency
      debt
      email
      fullName
      client
      currentTeam {
        nanoId
      }
      image {
        file
      }
    }
  }
`;
